// @flow
import type { AppState } from 'stores'
import { ChoroplethMap } from 'components/choroplethMap/choroplethMapComponent'
import { connect } from 'react-redux'

function mapStateToProps ({
  rentPricesByMunicipality,
  categorySelection
}: AppState) {
  return {
    currentBudget: categorySelection.priceRange,
    gemeinden: rentPricesByMunicipality
  }
}

const reduxConnectedChoroplethMap = connect(mapStateToProps)(ChoroplethMap)

export default reduxConnectedChoroplethMap
